import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Header.scss';
import { H3, Button } from 'design-system-web';
import { RequestModal } from '../Modal/RequestModal';

type HeaderProps = {
  disabled?: boolean;
  onNewOrderSuccess?: () => void;
};

export const Header: React.FC<HeaderProps> = ({
  disabled = false,
  onNewOrderSuccess,
}) => {
  const { t } = useTranslation();
  const [isRequestOpen, setIsRequestOpen] = useState(false);

  return (
    <div className={styles.headerBlock}>
      <div>
        <H3 className={styles.title}>
          {t('shared.integrations.vantify.maintenancerequests')}
        </H3>
      </div>
      <div className={styles.buttonBlock}>
        <Button
          className={styles.button}
          variant="primary"
          onClick={() => setIsRequestOpen(true)}
          disabled={disabled}
          size= 'large'
        >
          {t('shared.integrations.vantify.newrequest')}
        </Button>
      </div>
      {isRequestOpen && (
        <RequestModal
          isOpen={isRequestOpen}
          onClose={() => setIsRequestOpen(false)}
          onSuccess={onNewOrderSuccess}
        />
      )}
    </div>
  );
};
